module.exports = __webpack_public_path__ + "img/sl.d6c391f7.png";